import "./TheSound.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import TrackProductionShowcase from "./sections/TrackProductionShowcase";
export default function TheSoundPage() {
  return <div>
      <Header />
      <Hero />
      <TrackProductionShowcase />
      <Footer />
    </div>;
}